import { Dialog, DialogContent, Typography } from "@mui/material";
import { MprcDialogTitleClose } from "components";
import { useTranslation } from "react-i18next";
import { CommentBox, IDiscussionProps } from "views/knowledge/components/comment/CommentBox";

interface IProps {
    onClose: () => void;
    onUpdateCommentCounter?: (totalComments: number) => void;
}

type Props = IDiscussionProps & IProps;

///
export const CommentDialog: React.FC<Props> = (props) => {

    const { onClose, onUpdateCommentCounter, ...rest } = props;
    const { t } = useTranslation("knowledge");

    return (
        <Dialog
            open={true}
            fullWidth
            maxWidth="md"
            onClose={() => onClose}
        >
            <MprcDialogTitleClose
                title={
                    <>
                        {t("Publication.Comment.DialogTitle")} <br />
                        <Typography variant="caption" sx={{ textTransform: "initial" }}>
                            {props.publicationTitle}
                        </Typography>
                    </>
                }
                shrinkPadding
                onClose={onClose}
            />
            <DialogContent>
                <CommentBox onUpdateCommentCounter={onUpdateCommentCounter} isDialog {...rest} />
            </DialogContent>
        </Dialog>
    );
};
